/* eslint-disable arrow-body-style, max-len, react/jsx-no-bind, react/no-multi-comp, array-callback-return */
import React, {useState} from "react";
import PropTypes from "prop-types";

const AddToCartRings = ({allRingSizes, availableRingSizes, selectedRingSize, setSelectedRingSize}) => {
  const [isAdjustableOnly] = useState(availableRingSizes.length === 1 && availableRingSizes[0].toLowerCase() === "adjustable");

  const handleClick = (size) => {
    console.log("handleClick", size);
    setSelectedRingSize(size);
  };

  const parseSize = (size) => {
    return Number(size) || size;
  };

  const generateButton = ({size, isAvailable, isSelected}) => {
    const isText = typeof parseSize(size) === "string";

    let classes = "leading-none flex justify-center items-center h-[38px] w-auto rounded-full p-2 font-sans-demibold";
    classes += isText ? " capitalize" : " aspect-square";
    classes += isAvailable ? " cursor-pointer" : " cursor-not-allowed opacity-40";
    classes += isSelected
      ? " bg-neutral-800 text-white hover:bg-neutral-500"
      : " bg-neutral-100 text-neutral-800 hover:bg-neutral-200";

    return (
      <button
        className={classes}
        data-test={`${isSelected ? "selected" : "not-selected"}`}
        disabled={!isAvailable}
        key={`ring-size-${size}`}
        onClick={() => handleClick(size)}
        type="button"
      >
        {parseSize(size)}
      </button>
    );
  };

  const renderAdjustableRingButton = () => generateButton({
    "isAvailable": true,
    "isSelected": true,
    "size": "adjustable"
  });

  // const isAdjustableOnly = availableRingSizes.length === 1 && availableRingSizes[0].toLowerCase() === "adjustable";

  const isAvailable = size => availableRingSizes.some(ringSize => parseSize(ringSize) === parseSize(size));

  const isSelected = size => parseSize(size) === parseSize(selectedRingSize);

  const renderRingSizeButtons = () => allRingSizes.map((size) => {
    return generateButton({
      "isAvailable": isAvailable(size),
      "isSelected": isSelected(size),
      size
    });
  });

  return (
    <div
      className="selections-section flex-1"
      data-all-sizes={allRingSizes}
      data-available-sizes={availableRingSizes}
      data-test="add-to-cart-from-grid-rings"
    >
      <div className="px-2 text-left">
        Sizes
      </div>
      <div className="pt-2 flex-1">
        <div className="mx-1 flex gap-1 flex-wrap justify-center items-center">
          {isAdjustableOnly ? renderAdjustableRingButton() : renderRingSizeButtons()}
        </div>
      </div>
    </div>
  );
};

AddToCartRings.propTypes = {
  "allRingSizes": PropTypes.array.isRequired,
  "availableRingSizes": PropTypes.array,
  "isAvailable": PropTypes.bool,
  "isSelected": PropTypes.bool,
  "selectedRingSize": PropTypes.string,
  "setSelectedRingSize": PropTypes.func.isRequired,
  "size": PropTypes.string
};

AddToCartRings.defaultProps = {
  "availableRingSizes": [],
  "isAvailable": false,
  "isSelected": false,
  "selectedRingSize": null,
  "size": null
};

export default AddToCartRings;
